import Header from "components/Common/Header/Header";
import HeartRateBody from "components/PatientManagement/Vital/HeartRate/HeartRateBody";
import React, { useEffect } from "react";

const HeartRate = () => {
  useEffect(() => {
    document.title = "Vitals | Heart Rate";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="patientmanagement" />
      <HeartRateBody />
    </main>
  );
};

export default HeartRate;
